import { Injectable, signal } from '@angular/core';

/**
 * Form-scoped state tracking whether the user has tried to submit an
 * invalid form. Provided **locally** by DynamicFormComponent (not root)
 * so a second dialog opening in parallel doesn't inherit state from a
 * previous submission attempt.
 *
 * Any field type inside the form (e.g. `mat-tabs`) can inject this to
 * render an error summary or otherwise react to a failed submit.
 */
@Injectable()
export class FormValidationStore {
  readonly submitAttempted = signal(false);

  markAttempted(): void {
    this.submitAttempted.set(true);
  }

  reset(): void {
    this.submitAttempted.set(false);
  }
}
